import api from "@/services/api";
import type { VehicleDocumentHistoryResponse } from "../types";

export const getVehicleDocumentsHistory = async (vehicleId: number) => {
	const { data } = await api.get<VehicleDocumentHistoryResponse>(
		`/api/vehicles/${vehicleId}/documents/history`
	);
	return data;
};
